import { render } from "./ArrowUp.vue?vue&type=template&id=4807a3fd"
import script from "./ArrowUp.vue?vue&type=script&lang=js"
export * from "./ArrowUp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__